import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import Icon from '../shared/Icon';
import Text from '../shared/Text';
import { breakpoints, palette } from '../../constants/styles';

const StyledLabel = css`
  margin-top: 10px;
  padding: 0px 10px;
`;

const StyledOptionWithIcon = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const StyledSpan = styled.span`
  display: none;
  ${breakpoints.tabletLandscape} {
    align-self: flex-start;
    justify-self: flex-start;
    margin-top: 26px;
    margin-left: -30px;
    position: fixed;
    font-size: 0.8em;
    font-weight: 500;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 20px;
    max-height: 15px;
    background-color: ${palette.secondaryColorShy};
    padding: 5px;
    border-radius: 8px;
    border-color: ${palette.sweetGray};
    border: 1px solid;
    color: ${palette.sweetGray};
  }
`;

const OptionWithIcon = ({ children, icon, dimensions, hotkey }) => (
  <StyledOptionWithIcon>
    <Icon icon={icon} color="gray" size={dimensions} />
    <Text type="body1" styles={StyledLabel} light>{children}</Text>
    <StyledSpan>{hotkey}</StyledSpan>
  </StyledOptionWithIcon>
);

OptionWithIcon.propTypes = {
  children: PropTypes.string,
  icon: PropTypes.string,
  dimensions: PropTypes.number,
  hotkey: PropTypes.string,
};

OptionWithIcon.defaultProps = {
  hotkey:'',
  children: '',
  icon: '',
  dimensions: 30,
};

export default OptionWithIcon;
